import axios from "axios"
import config from "../config"
import { fromJS } from "immutable"

export const reset = () => {
    return {
        type: "CALL_INTELLIGENCE_RESET",
    }
}

export const setEnv = data => {
    return {
        type: "CALL_INTELLIGENCE_SET_ENV",
        data,
    }
}

export const setTranscriber = data => {
    return {
        type: "CALL_INTELLIGENCE_SET_TRINSCRIBER",
        data,
    }
}

export const setMessage = msg => {
    return {
        type: "CALL_INTELLIGENCE_SET_MESSAGE",
        data: msg,
    }
}

export const clearDiff = () => {
    return { type: "CALL_INTELLIGENCE_CLEAR_DIFF" }
}

export const clear = () => {
    return { type: "CALL_INTELLIGENCE_CLEAR" }
}

export const env = () => {
    return new Promise((resolve, reject) => {
        axios
            .get(`${config.apiEndpoint}addon/call_intelligence/env`)
            .then(response => {
                resolve(response.data)
            })
            .catch(e => {
                if (e.response && e.response.data && e.response.data.msg) reject(e.response.data.msg)
                else reject(e.message)
            })
    })
}

export const transcriber = () => {
    return new Promise((resolve, reject) => {
        axios
            .get(`${config.apiEndpoint}addon/call_intelligence/transcriber`)
            .then(response => resolve(response.data))
            .catch(e => {
                if (e.response && e.response.data && e.response.data.msg) reject(e.response.data.msg)
                else reject(e.message)
            })
    })
}

export const available = () => {
    return new Promise((resolve, reject) => {
        axios
            .get(`${config.apiEndpoint}addon/call_intelligence/available`)
            .then(response => resolve(response.data))
            .catch(e => {
                if (e.response && e.response.data && e.response.data.msg) reject(e.response.data.msg)
                else reject(e.message)
            })
    })
}

export const init = (call_id, options) => {
    return new Promise((resolve, reject) => {
        axios
            .post(`${config.apiEndpoint}addon/call_intelligence/${call_id}/init`, options)
            .then(() => resolve())
            .catch(e => {
                if (e.response && e.response.data && e.response.data.msg) reject(e.response.data.msg)
                else reject(e.message)
            })
    })
}

export const next_phrase = (call_id, messages) => {
    return new Promise((resolve, reject) => {
        axios
            .post(`${config.apiEndpoint}addon/call_intelligence/${call_id}/next_phrase`, messages)
            .then(response => resolve(response.data))
            .catch(e => {
                if (e.response && e.response.data && e.response.data.msg) reject(e.response.data.msg)
                else reject(e.message)
            })
    })
}

export const finish = (call_id, messages) => {
    return new Promise((resolve, reject) => {
        axios
            .post(`${config.apiEndpoint}addon/call_intelligence/${call_id}/finish`, messages)
            .then(response => resolve(response.data))
            .catch(e => {
                if (e.response && e.response.data && e.response.data.msg) reject(e.response.data.msg)
                else reject(e.message)
            })
    })
}

export const getProperty = contactId => () =>
    new Promise((resolve, reject) => {
        axios
            .get(`${config.apiEndpoint}contact/${contactId}/property`)
            .then(response => {
                resolve(fromJS(response.data))
            })
            .catch(e => {
                if (e.response && e.response.data && e.response.data.msg) reject(e.response.data.msg)
                else reject(e.message)
            })
    })

export const getPropertyImages = contactId => () =>
    new Promise((resolve, reject) => {
        axios
            .get(`${config.apiEndpoint}contact/${contactId}/property-images`)
            .then(response => {
                resolve(fromJS(response.data || []))
            })
            .catch(e => {
                if (e.response && e.response.data && e.response.data.msg) reject(e.response.data.msg)
                else reject(e.message)
            })
    })
